// import { DonutSmallOutlined, AdminPanelSettingsOutlined, BusinessOutlined, PaymentOutlined, VpnKeyOutlined, SettingsOutlined } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';

import { IconHome, IconUsers, IconWorld, IconCurrencyDollar, IconKey, IconSettings, IconLockOpen2, IconDeviceDesktopCog, IconReceipt2, IconBuildingStore, IconRegistered, IconServer } from '@tabler/icons-react';

import { Authentication } from "../../Models/Authentication/Authentication";

import SettingsHelper from './SettingsHelper';
import LocalStorageHelper from "./LocalStorageHelper";
import RouteHelper from "./RouteHelper";
import AccessibilityHelper from "./AccessibilityHelper";

import { RouteEnum } from '../Enums/RouteEnums';
import { FileSizeType, FileSizeValueType } from '../Enums/FileEnum';
import { AdminModules } from '../Enums/AdminModulesEnum';
import { AuthenticationField } from "../Enums/ParametersEnum";
import { CurrencyEnum } from '../Enums/CurrencyEnums';

import { AssetImages } from '../../Constants/Assets';
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

const GlobalFunctionHelper = {
    getSideMenuItems: function () {
        let _modules: any = [
            {
                id: AdminModules.DASHBOARD_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.DASHBOARD),
                icon: <IconHome size={20} />,
                route: RouteEnum.DASHBOARD
            },
            {
                id: AdminModules.ADMIN_USER_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.ADMIN_USER_CONTROL),
                icon: <IconUsers size={20} />,
                route: RouteEnum.ADMIN_USER_CONTROL
            },
            {
                id: AdminModules.COMPANY_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.COMPANIES),
                icon: <IconWorld size={20} />,
                route: RouteEnum.COMPANIES
            },
            {
                id: AdminModules.BILLING_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.BILLINGS),
                icon: <IconCurrencyDollar size={20} />,
                route: RouteEnum.BILLINGS
            },
            {
                id: AdminModules.LICENSE_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.LICENSES),
                icon: <IconKey size={20} />,
                route: RouteEnum.LICENSES
            },
            {
                id: AdminModules.INSTANCE_MANAGEMENT_VIEW,
                title: RouteHelper.getRouteDescription(RouteEnum.INSTANCE_MANAGEMENT),
                icon: <IconServer size={20} />,
                route: RouteEnum.INSTANCE_MANAGEMENT
            },
            {
                id: 0,
                title: RouteHelper.getRouteDescription(RouteEnum.MAINTENANCE),
                icon: <IconSettings size={20} />,
                route: RouteEnum.MAINTENANCE,
                submenu: [
                    {
                    id: AdminModules.ACCESSIBILITIES_VIEW,
                    title: RouteHelper.getRouteDescription(RouteEnum.ACCESSIBILITIES),
                    icon: <IconLockOpen2 size={20} />,
                    route: RouteEnum.ACCESSIBILITIES
                    },
                    {
                        id: AdminModules.MODULE_SETTINGS_VIEW,
                        title: RouteHelper.getRouteDescription(RouteEnum.MODULE_SETTING),
                        icon: <IconDeviceDesktopCog size={20} />,
                        route: RouteEnum.MODULE_SETTING
                    },
                    {
                        id: AdminModules.PRICE_SETTINGS_VIEW,
                        title: RouteHelper.getRouteDescription(RouteEnum.PRICE_SETTING),
                        icon: <IconReceipt2 size={20} />,
                        route: RouteEnum.PRICE_SETTING
                    },
                    {
                        id: AdminModules.VENDORS_VIEW,
                        title: RouteHelper.getRouteDescription(RouteEnum.VENDORS),
                        icon: <IconBuildingStore size={20} />,
                        route: RouteEnum.VENDORS
                    },
                    // {
                    //     id: AdminModules.REGISTRATION_CODES_VIEW,
                    //     title: RouteHelper.getRouteDescription(RouteEnum.REGISTRATION_CODES),
                    //     icon: <IconRegistered size={20} />,
                    //     route: RouteEnum.REGISTRATION_CODES
                    // },
                ]
            }
        ];

        let _accessedModules: any = this.accessedModules(_modules);

        return _accessedModules;
    },
    accessedModules: function (_modules: any) {
        let _accessedModules: any = [];

        _modules?.forEach((moduleItem: any, moduleIndex: number) => {
            if(moduleItem.id == 0 || AccessibilityHelper.hasAccess(moduleItem.id)) {
                let _moduleItem: any = (moduleItem?.submenu?.length > 0 ?
                    { ...moduleItem, submenu: this.accessedModules(moduleItem?.submenu ?? [])} : { ...moduleItem }
                );

                _accessedModules.push(_moduleItem)
            }
        });

        return _accessedModules.filter((item: any) => item.id > 0 || (item.id == 0 && (item?.submenu?.length ?? 0) > 0) );
    },
    initializeWebTheme: function (title = null) {
        SettingsHelper.UpdateWebPageDetails();

        return {
            ...this.initializeWebSettings(),
        }
    },
    initializeWebSettings: function () {
        let getSettings = SettingsHelper.getSettingsData();
        let _pathName = window.location.pathname;
        let _isFogotPassword = LocalStorageHelper.isForgotPassword();
        let _showExpiredTokenNotif = false;

        if (_isFogotPassword === true && _pathName == RouteEnum.FORGOT_PASSWORD) {
            window.history.replaceState(null, StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER, RouteEnum.FORGOT_PASSWORD);
            document.title = StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER;
        } else if(_pathName == RouteEnum.SIGN_UP) {
            window.history.replaceState(null, StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER, RouteEnum.SIGN_UP);
            document.title = StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER;
        } else if(_pathName == RouteEnum.LOGOUT) {
            window.history.replaceState(null, StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER, RouteEnum.LOGOUT);
            document.title = StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER;
        } else if (getSettings.errorCode == 401 && _pathName != RouteEnum.LOGIN) {    
            // window.history.replaceState(null, StaticDisplayText.APP_NAME + " - " + StaticDisplayText.APP_HEADER, RouteEnum.LOGIN);
            window.location.replace(RouteEnum.LOGIN);
            document.title = StaticDisplayText.APP_NAME + " - " + RouteHelper.getRouteDescription(RouteEnum.LOGIN);
            
            LocalStorageHelper.clearLocalStorage();

            if (_pathName != null && _pathName != "" && _pathName != RouteEnum.LOGIN) {
                _showExpiredTokenNotif = true;
            }
        } else if(_pathName == RouteEnum.HOME) {
            window.location.replace(RouteEnum.DASHBOARD);
        } else if (getSettings.data) {

        }


        return {
            showExpiredTokenNotif: _showExpiredTokenNotif,
        };
    },
    getWebAppLogo: function () {
        let x70SettingsData = (SettingsHelper.getSettingsData()?.data ? SettingsHelper.getSettingsData().data : null);
        let x70Logo = (x70SettingsData?.favicon ? x70SettingsData.favicon : AssetImages.WEB_APP_FAVICON);

        return x70Logo;
    },
    getRanHex: function (size: any) {
        return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')
    },
    getMenuPathData: async function (search: any, fieldName: any) {
        let menuPathData = null;
        let exitLoop = false;

        if (search != null && search != "") {
            let _modules: any = await this.getSideMenuItems();

            _modules?.forEach((item: any, index: any) => {
                if (!exitLoop) {
                    if (item[fieldName] == search) {
                        menuPathData = item;

                        exitLoop = true;
                    } else {
                        if (item.hasSubMenu) {
                            menuPathData = this.getPathData(item.subMenuItems, search, fieldName);

                            if (menuPathData != null) {
                                exitLoop = true;
                            }
                        }
                    }
                }
            });
        }

        return menuPathData;
    },
    getPathData: function (menuItems: any, search: any, fieldName: any) {
        let menuPathData = null;
        let exitLoop = false;

        menuItems.forEach((item: any, index: any) => {
            if (!exitLoop) {
                if (item[fieldName] == search) {
                    menuPathData = item;

                    exitLoop = true;
                } else {
                    if (item.hasSubMenu) {
                        menuPathData = this.getPathData(item.subMenuItems, search, fieldName);

                        if (menuPathData != null) {
                            exitLoop = true;
                        }
                    }
                }
            }
        });

        return menuPathData;
    },
    isNewIDChecker: function (id?: string | number | undefined | null) {
        if (!id || id == 0 || id == '0' || id == "")
            return true
        return false
    },
    getCurrencyCode: function () {
        let userData: Authentication = LocalStorageHelper.getUserData();

        return (userData?.[AuthenticationField.CURRENCY_CODE] ?? CurrencyEnum.PHP);
        // return "PHP";
    },
    getDisplayCurrencyCode: function (showOriginalCode: boolean = false) {
        let currencyCode = this.getCurrencyCode();

        return showOriginalCode ? currencyCode : (currencyCode != CurrencyEnum.MYR ? currencyCode : "RM");
        // return "PHP";
    },
    amountFormatter: function (amount: number = 0, fixedDecimalPlaces: number = 2, showCurrency: boolean = false, noRoundOff: boolean = false) {
        let currencyCode = this.getDisplayCurrencyCode();
        let amt: number = isNaN(parseFloat((amount ?? 0).toString())) ? 0 : parseFloat((amount ?? 0).toString());
        let parts: any = (!noRoundOff ? (+amt).toFixed(fixedDecimalPlaces).split(".") : (+amt).toFixed(fixedDecimalPlaces + 1).slice(0,-1).split("."));
        let withComma: string = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

        return `${showCurrency ? currencyCode : ""} ${withComma}`
    },
    percentToDecimal: function (percentAmount: number = 0) {
        return percentAmount / 100;
    },
    convertFileSize: function (value: any, fromSizeType: any = FileSizeType.KB, toSizeType: any = FileSizeType.KB) {
        let _fromSizeType: any = FileSizeValueType?.[fromSizeType] ?? 0;
        let _toSizeType: any = FileSizeValueType?.[toSizeType] ?? 0;

        let _convertedValue: any = (_fromSizeType <= _toSizeType ? (value / _toSizeType) : (value * _fromSizeType));
        
        return parseFloat((_convertedValue).toFixed(2));
    },
    getBypassLogin: function () {
        return (window.location.pathname.toLowerCase().includes(RouteEnum.SIGN_UP) || window.location.pathname.toLowerCase().includes(RouteEnum.LOGOUT) || window.location.pathname.toLowerCase().includes(RouteEnum.FORGOT_PASSWORD) || window.location.pathname.toLowerCase().includes(RouteEnum.OTP) || window.location.pathname.toLowerCase().includes(RouteEnum.RECOVER_ACCOUNT));
    },
    getUUID: function () {
        return uuidv4();
    },
    timeout: async function (ms: number) {
        return new Promise((resolve: any) => setTimeout(resolve, ms));
    },
    goBack: function (navigate: any, location: any, routePath: any) {
        if(routePath != null && routePath != "" && navigate != null && navigate != "") {
            if (location?.key == 'default') {
                navigate(routePath, { replace: true });
            } else {
                navigate(-1);
            }
        }

        return true;
    },
    formatTime: function (totalSeconds: number) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        
        return `${minutes}m ${seconds}s`;
    },
}

export function isReactElement(arg: any): arg is React.ReactElement {
    return arg.hasOwnProperty("type");
}

export default GlobalFunctionHelper;